<template>
  <v-row no-gutters>
    <v-col>
      <div v-if="userStatus" id="order-list" :class="{ 'page-fullscreen': pageStore.isFullScreen }">
        <!-- app drawer -->
        <v-progress-circular v-if="pageLoading" class="el-center" :size="120" indeterminate>
          <span class="text-caption">Yükleniyor</span>
        </v-progress-circular>

        <v-snackbar
          v-model="snackbar"
         
          color="info"
          right
          timeout="5000"
          elevation="24"
          
        >
          Sepete eklediğiniz <strong><u>"{{ snackbarText }}"</u></strong> ürünü sadece 2 ve katları şeklinde
          satın alabilirsiniz.
          <template v-slot:action="{ attrs }">
            <v-btn color="secondary" small depressed  v-bind="attrs" @click="snackbar = false"> Kapat </v-btn>
          </template>
        </v-snackbar>

        <v-snackbars
          :objects.sync="snackbarBasket"
          width="500"
          :timeout="1500"
          bottom
          right
          color="error"
          transition="slide-y-transition"
        >
          <template v-slot:default="{ message }">
            <div v-if="message.status">
              <div class="text-body-1 font-weight-bold">
                {{ message.product }}
              </div>
              <div>
                Ürününden <strong> {{ message.count }} {{ message.birim }}</strong>
                <v-chip :color="message.color" label class="ml-1" small>
                  {{ message.plant }} Fabrikasından
                </v-chip>
                sepetinize eklendi
              </div>
            </div>
            <div v-else>
              <div class="text-body-1 font-weight-bold">
                {{ message.product }}
              </div>
              <div>
                <strong> Sepetten çıkartıldı</strong>
              </div>
            </div>
          </template>
          <template v-slot:action="{ close }">
            <v-btn icon small @click="close()">
              <v-icon small>
                {{ icons.mdiClose }}
              </v-icon>
            </v-btn>
          </template>
        </v-snackbars>

        <customer-list v-if="userData.role === 'PLSYR' && $vuetify.breakpoint.xsOnly" />

        <div v-if="appStore.hasOverdueMutabakat" class="px-3">
          <mutabakat-order-blocked-alert />
        </div>

        <v-card
          v-else-if="!pageLoading"
          tile
          :class="$vuetify.breakpoint.mdAndDown ? null : 'rounded-t-xl'"
        >
          <!-- table -->
          <PageHeader />

          <v-data-table
            :headers="tableColumns"
            :items="tableRows"
            :items-per-page="-1"
            :mobile-breakpoint="100"
            :height="pageStore.tableHeight"
            fixed-header
            :loading="tableLoading"
            hide-default-footer
          >
            <!-- Arama Alanı -->
            <template v-slot:body.prepend>
              <tr style="zoom: 0.8; position: sticky; z-index: 2; top: 40px; background: #363351">
                <!-- Ürün Kodu -->
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchCode"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>

                <!-- Kategori -->
                <td class="pa-0">
                  <v-autocomplete
                    v-model="tableSearchCategorie"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    item-value="text"
                    :items="productCategories"
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                    attach
                    :menu-props="{ bottom: true, offsetY: true }"
                  />
                </td>

                <!-- Başlık -->
                <td class="pa-0">
                  <v-text-field
                    v-model="tableSearchTitle"
                    :prepend-inner-icon="icons.mdiMagnify"
                    persistent-placeholder
                    clearable
                    placeholder="Ara"
                    filled
                    class="rounded-0 elevation-0"
                    hide-details
                  />
                </td>

                <!-- Boş -->
                <td class="pa-0">
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>

                <!-- Boş -->
                <td class="pa-0">
                  <v-text-field filled disabled class="rounded-0 elevation-0" hide-details />
                </td>
              </tr>
            </template>

            <template #[`item.urun_kodu`]="{ item }">
              <v-chip label color="chip">
                <span style="font-size: 11px !important; letter-spacing: 0.5px; color: azure">
                  {{ item.urun_kodu }}</span
                >
              </v-chip>
            </template>

            <template #[`item.kategori`]="{ item }">
              <v-chip color="grey" class="d-flex justify-center" label>
                <div
                  class="text-truncate text-uppercase"
                  style="
                    width: 200px !important;
                    text-align: center;
                    font-size: 11px !important;
                    letter-spacing: 0.5px;
                    color: azure;
                  "
                >
                  {{ item.kategori }}
                </div>
              </v-chip>
            </template>

            <template #[`item.baslik`]="{ item }">
              <div class="d-flex align-center">
                <div class="mr-2">
                  <v-tooltip v-if="item.pictures" left color="white">
                    <template v-slot:activator="{ on, attrs }">
                      <v-sheet
                        width="32"
                        height="32"
                        color="secondary"
                        class="d-flex align-center justify-center"
                        rounded
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon color="white" size="18">
                          {{ icons.mdiCamera }}
                        </v-icon>
                      </v-sheet>
                    </template>
                    <v-img width="300" height="300" :src="$baseUrlAPI + '' + item.pictures"></v-img>
                  </v-tooltip>
                  <v-sheet
                    v-else
                    width="32"
                    height="32"
                    color="primary"
                    class="d-flex align-center justify-center"
                    rounded
                  >
                    <v-icon color="white" size="18">
                      {{ icons.mdiCameraOff }}
                    </v-icon>
                  </v-sheet>
                </div>
                <div>
                  <div class="text-body-2 white--text">{{ baslikSplit(item.baslik, 0) }}</div>
                  <div class="primary--text text-caption" style="line-height: 1">
                    {{ baslikSplit(item.baslik, 1) }}
                  </div>
                </div>
              </div>
            </template>

            <template #[`item.satis_fiyati`]="{ item }">
              <span class="text-body-2 white--text"> {{ item.satis_fiyati | currency }}</span>
            </template>

            <template #[`item.siparis_miktari`]="{ item }">
              <div class="d-flex justify-end align-center">
                <Counter
                  :uid="item.id"
                  :birim="item.birim || 'AD'"
                  :birim-ritim="Number(item.ritim)"
                  :miktar="item.pic"
                  plant-id="01"
                  bg-color="transparent elevation-0"
                  button-color="white"
                  :dark="true"
                  :light="false"
                  :status="false"
                  :filled="false"
                  :solo="true"
                  :kategori="$route.params.type === 'mamul' ? 'Mamül' : 'Sarf'"
                  @miktarGonder="miktarEkle"
                ></Counter>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </div>
      <div v-else>
        <customer-list v-if="userData.role === 'PLSYR' && $vuetify.breakpoint.xsOnly" />
        <v-alert
          text
          outlined
          class="mx-3 mx-lg-0 rounded-pill mt-2 mt-md-0 text-caption"
          type="warning"
        >
          Lütfen yukarıdan bir müşteri seçin
        </v-alert>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import Counter from "@/components/Counter.vue";
import CustomerList from "@/components/CustomerList.vue";
import store from "@/store";
import orderStoreModule from "@/views/order/orderStoreModule";
import { useRouter } from "@core/utils";
import PageHeader from "@/components/PageHeader/Index.vue";
import { usePageStore } from "@/stores/pageHeader";
import { useAppStore } from "@/stores/app";
import MutabakatOrderBlockedAlert from "@/components/MutabakatOrderBlockedAlert.vue";

import {
  mdiCamera,
  mdiCameraOff,
  mdiChefHat,
  mdiClose,
  mdiCollage,
  mdiDelete,
  mdiEye,
  mdiEyeOff,
  mdiFilter,
  mdiFilterOff,
  mdiFlash,
  mdiMagnify,
  mdiMenuDown,
  mdiMenuUp,
  mdiPlusThick,
  mdiSquareEditOutline,
} from "@mdi/js";
import { onMounted, onUnmounted, ref, watch } from "vue-demi";

import VSnackbars from "v-snackbars";
import Vue from "vue";

export default {
  components: {
    Counter,
    VSnackbars,
    PageHeader,
    CustomerList,
    MutabakatOrderBlockedAlert,
  },
  setup() {
    // Helpers
    const { route, router } = useRouter();
    const PRODUCT_APP_STORE_MODULE_NAME = "app-order";
    const pageStore = usePageStore();
    const appStore = useAppStore();
    // Sayfa Özellikleri
    const pageSettings = () => {
      pageStore.pageTitle = title.value;
      pageStore.pageIcon = titleIcon.value;
      pageStore.hasFullScreen = true;
      pageStore.hasDownload = false;
      pageStore.hasDateRangeAll = false;
      pageStore.hasDateRange = false;
      pageStore.hasActions = false;
    };
    // Register module
    if (!store.hasModule(PRODUCT_APP_STORE_MODULE_NAME)) {
      store.registerModule(PRODUCT_APP_STORE_MODULE_NAME, orderStoreModule);
    }

    // Page
    const userData = JSON.parse(localStorage.getItem("userData"));
    const pageLoading = ref(true);
    const userStatus = ref(false);
    onMounted(() => {
      titleFn();
      pageSettings();

      if (userData.role === "PLSYR" && store.state.plasiyerCustomer === null) {
        userStatus.value = false;
      } else if (userData.role === "CUST" || userData.role === "BAYI" || userData.role === "SUBE") {
        userStatus.value = true;
      } else {
        userStatus.value = true;
      }
    });

    watch(
      () => store.state.plasiyerCustomer,
      () => {
        if (store.state.plasiyerCustomer) {
          userStatus.value = true;
        }
      }
    );

    // Title
    watch(
      () => route.value.params.type,
      () => {
        titleFn();
        pageSettings();
      }
    );

    const title = ref("");
    const titleIcon = ref("");

    const titleFn = () => {
      tableRows.value = [];
      productCategories.value = [];
      tableLoading.value = true;
      tableSearchCode.value = "";
      tableSearchTitle.value = "";
      tableSearchCategorie.value = "";
      if (route.value.params.type === "mamul") {
        title.value = "Mamül Sipariş";
        titleIcon.value = mdiChefHat;
        productCategorie.value = 1;
        fetchCategories(1);
        fetchProducts(1);
      } else if (route.value.params.type === "sarf") {
        title.value = "Sarf Sipariş";
        titleIcon.value = mdiCollage;
        productCategorie.value = 2;
        fetchCategories(2);
        fetchProducts(2);
      }
    };

    // Tab
    const tabChange = (val) => {
      fetchProducts(val);
    };

    // Table
    const tableLoading = ref(false);
    const tableSearchCode = ref("");
    const tableSearchCategorie = ref("");
    const tableSearchTitle = ref("");

    const tableRows = ref([]);
    const tableColumns = [
      {
        text: "Kod",
        value: "urun_kodu",
        width: "120px",
        filter: (f) => {
          if (tableSearchCode.value === null) tableSearchCode.value = "";
          return f.toLowerCase().includes(tableSearchCode.value.toLowerCase());
        },
      },
      {
        text: "Kategori",
        value: "kategori",
        width: "200px",
        filter: (f) => {
          if (tableSearchCategorie.value === null) tableSearchCategorie.value = "";
          return f.toLowerCase().includes(tableSearchCategorie.value.toLowerCase());
        },
      },

      {
        text: "Ürün",
        value: "baslik",
        class: "min-width-600",
        filter: (f) => {
          if (tableSearchTitle.value === null) tableSearchTitle.value = "";
          return f.toLowerCase().includes(tableSearchTitle.value.toLowerCase());
        },
      },
      {
        text: "Birim Fiyat",
        value: "satis_fiyati",
        filterable: false,
        width: "140px",
        align: "right",
      },
      {
        text: "Sipariş Miktarı",
        value: "siparis_miktari",
        filterable: false,
        width: "220px",
        align: "right",
        sortable: false,
      },
    ];

    // Basket
    const snackbarBasket = ref([]);
    watch(
      () => store.getters["app/basketDrawer"],
      () => {
        fetchBasketList();
      }
    );
    watch(
      () => store.getters["app/basketDelete"],
      () => {
        itemDelete();
      }
    );
    const itemDelete = () => {
      tableRows.value.find((el) => {
        if (el.id == store.state.app.basketDelete) {
          el.pic = 0;
        }
      });
    };
    const fetchBasketList = () => {
      store.dispatch("app-order/fetchActiveBasketList").then((response) => {
        if (!response.error) {
          if (response.detail) {
            tableRows.value.filter((item) => {
              response.detail.find((el) => {
                if (el.uid == item.id) {
                  item.pic = Number(el.qty);
                }
              });
            });
          } else {
            tableRows.value.filter((item) => {
              item.pic = 0;
            });
          }
        }
      });
    };

    // Products
    const productCategories = ref([]);
    const productCategorie = ref(route.value.params.type === "mamul" ? 1 : 2);
    const fetchCategories = (val) => {
      productCategories.value = [];
      const id = val;
      const page = 1;
      const count = 6;
      const plant = "01";
      const method = "getProductsByCtgId";
      store
        .dispatch("postMethod", {
          method,
          id,
          page,
          count,
          plant,
        })
        .then((response) => {
          if (response.error === true) {
            return;
          }

          for (const [key, value] of Object.entries(response.detail.categories)) {
            if (value.ust == val) {
              productCategories.value.push({
                value: value.id,
                text: value.kategori,
              });
            }
          }
        });
    };
    const productCategorieClear = () => {
      setTimeout(() => {
        productCategorie.value = route.value.params.type === "mamul" ? 1 : 2;
      }, 100);
    };
    const changeCategorie = () => {
      fetchProducts(productCategorie.value);
    };
    const fetchProducts = (type = 1) => {
      const id = type || 1;
      const page = 1;
      const count = 6;
      const plant = "01";
      const method = "getProductsByCtgId";
      store
        .dispatch("postMethod", {
          method,
          id,
          page,
          count,
          plant,
        })
        .then((response) => {
          if (response.error) {
            Vue.swal({
              title: "Başarısız",
              text: response.msg,
              width: "350px",
              icon: "error",
              background: "#FF4C51",
              showCloseButton: false,
              showConfirmButton: true,
              confirmButtonColor: "#cc3d41",
            });

            router.push({ name: "dashboard" });

            return;
          }

          const productList = response.detail.products.map((item) => {
            const items = {};
            items.id = item.id;
            items.birim = item.birim;
            items.ritim = item.birim_ritmi;
            items.kategori = item.kategori;
            items.urun_kodu = item.urun_kodu;
            items.baslik = item.baslik;
            items.kid = item.kid;
            items.pictures = item.resim;
            items.satis_fiyati = item.satis_fiyati;
            items.pic = 0;

            return items;
          });
          tableRows.value = productList;
          pageLoading.value = false;
          tableLoading.value = false;
          fetchBasketList();
        })
        .catch((e) => {
          Vue.swal({
            title: "Hata",
            text: e.message,
            width: "350px",
            icon: "error",
            background: "#FF4C51",
            showCloseButton: false,
            showConfirmButton: true,
            confirmButtonColor: "#cc3d41",
          });
        });
    };
    const baslikSplit = (val, index) => {
      let result;
      if (val.split("(").length > 1) {
        if (index === 0) {
          result = val.split("(")[index].slice(0, -1);
        } else {
          result = `(${val.split("(")[index].slice(0, -1)})`;
        }
      } else if (index === 0) {
        result = val;
      }

      return result;
    };

    const snackbar = ref(false);
    const snackbarText = ref("");
    const miktarEkle = (val, uid) => {
      tableRows.value.find((item) => {
        if (item.id == uid) {
          if (item.ritim == 2) {
            snackbar.value = true;
            
            snackbarText.value = item.baslik;
          }
          item.pic = val;
        }
      });
    };

    onUnmounted(() => {
      pageStore.pageSettingsClear();
    });
    return {
      miktarEkle,
      snackbar,
      snackbarText,
      appStore,
      // Page
      userData,
      userStatus,
      pageLoading,

      // Title
      title,
      titleIcon,

      // Tab
      tabChange,

      // Table
      tableLoading,
      tableRows,
      tableColumns,
      tableSearchCode,
      tableSearchCategorie,
      tableSearchTitle,

      // Basket
      snackbarBasket,
      fetchBasketList,

      // Products
      fetchProducts,
      productCategories,
      productCategorie,
      productCategorieClear,
      changeCategorie,
      baslikSplit,
      pageStore,
      icons: {
        mdiMenuDown,
        mdiMenuUp,
        mdiCamera,
        mdiDelete,
        mdiCameraOff,
        mdiFlash,
        mdiEye,
        mdiEyeOff,
        mdiFilter,
        mdiFilterOff,
        mdiPlusThick,
        mdiSquareEditOutline,
        mdiClose,
        mdiMagnify,
        mdiChefHat,
        mdiCollage,
      },
    };
  },
};
</script>

<style lang="scss">
@import "~@core/layouts/styles/_variables";

.search-mobil-plasiyer {
  position: fixed;
  z-index: 5;
  width: 100%;
  left: 0;
  top: 135px !important;
}
.text-plain {
  font-size: 10px;
  line-height: 1;
  padding-bottom: 2px;
}
.po-0 {
  .v-toolbar__content {
    padding: 0px 18px 0px 15px !important;
  }
}

.style-1 {
  background-color: rgba(255, 255, 255, 0.05);
}
.style-2 {
  // background-color: rgb(114, 114, 67);
}

.v-tooltip__content {
  opacity: 1 !important;
  box-shadow: 5px 5px 10px 0px rgb(0 0 0 / 30%) !important;
}
.siparis-tab .v-tabs-slider-wrapper {
  display: none;
}

.siparis-tab .v-tab {
  font-size: 11px !important;
  color: white !important;
  border-radius: 50px;
  // border-radius: 0px;
  // background-color: #3b3854 !important;
  background-color: #ff151a !important;
  box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset, rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset,
    rgba(0, 0, 0, 0.06) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,
    rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,
    rgba(0, 0, 0, 0.09) 0px 32px 16px;
}
.siparis-tab .v-tab--active {
  background-color: #0d6efd !important;
}
.siparis-hepsi {
  .v-tab {
    background-color: #dfdfdf;
  }
  .v-slide-group__content {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 18px;
    grid-row-gap: 18px;
    padding: 18px;

    // grid-column-gap: 1px;
    // grid-row-gap: 1px;
    // padding: 0px;
  }
}
@media screen and (max-width: 599px) {
  .siparis-tab .v-tab {
    font-size: 11px !important;
    color: white !important;
    border-radius: 0px !important;
    background-color: #ff151a !important;
    box-shadow: none !important;
  }
  .siparis-tab .v-tab--active {
    background-color: #0d6efd !important;
  }
  .siparis-hepsi {
    .v-tab {
      background-color: #dfdfdf;
    }
    .v-slide-group__content {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-column-gap: 1px;
      grid-row-gap: 1px;
      padding: 0px;
    }
  }
}
.satirVar {
  .v-toolbar__content {
    flex-direction: column;
    margin: 10px 0;
  }
}
</style>
